import { render, staticRenderFns } from "./myBuyers.vue?vue&type=template&id=7f2a4b19&scoped=true&lang=html&"
import script from "./myBuyers.vue?vue&type=script&lang=js&"
export * from "./myBuyers.vue?vue&type=script&lang=js&"
import style0 from "./myBuyers.vue?vue&type=style&index=0&id=7f2a4b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a4b19",
  null
  
)

export default component.exports